import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { ModelUnitPerModel } from '../models/modelUnitModel';
import {
  editModelUnitInBulkEndpoint,
  markUnitsPerModelAvailableInBulkEndpoint,
  retrieveModelUnitInCSVEndpoint,
  retrieveUnitsPerModelEndpoint,
} from '../services/projectModelUnitService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

const useProjectModelUnit = () => {
  const { isLoading, callEndpoint, callEndpointWBlob } = useCallApiAndLoad();
  const [apiErrors, setApiErrors] = useState<string | null>(null);
  const [apiSuccess, setApiSuccess] = useState<string | null>(null);
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const doRetrieveUnitsPerModel = async (
    model_id: string,
    unit_status: string[] = [],
  ): Promise<ModelUnitPerModel[]> => {
    let result: ModelUnitPerModel[] = [];

    let unit_status_aux =
      unit_status.length > 0 ? unit_status.join(',') : 'created';

    const { data, status } = await callEndpoint(
      retrieveUnitsPerModelEndpoint(
        model_id,
        {
          by_status: unit_status_aux,
        },
        token,
      ),
    );

    const response = fetchResponseAdapter(data);

    if (status === 200) {
      //success
      result = response.data;
    } else {
      //error
      setApiErrors(response.message);
    }

    return result;
  };

  const doActivateUnitsPerModel = async (
    model_id: string,
    units_ids: string[],
  ): Promise<boolean> => {
    let result: boolean = false;

    const { data, status } = await callEndpoint(
      markUnitsPerModelAvailableInBulkEndpoint(
        model_id,
        {
          units_ids: units_ids,
        },
        token,
      ),
    );

    const response = fetchResponseAdapter(data);

    if (status === 200) {
      //success
      result = true;
      setApiSuccess(`Unidades [${units_ids.length}] activadas correctamente!`);
    } else {
      //error
      setApiErrors(response.message);
    }

    return result;
  };

  const doRetrieveUnitsPerModelViaCsv = async (
    model_id: string,
    units_ids: string[],
  ): Promise<boolean> => {
    let result: boolean = false;

    const { status, data } = await callEndpointWBlob(
      retrieveModelUnitInCSVEndpoint(
        model_id,
        {
          units_ids: units_ids,
        },
        token,
      ),
    );

    const response = fetchResponseAdapter(data);

    if (status === 201) {
      //success
      result = true;
      setApiSuccess('Archivo generado con éxito');
    } else {
      //error
      setApiErrors(response.message);
    }

    return result;
  };

  const doEditUnitsPerModelInBulk = async (
    model_id: string,
    form: any,
  ): Promise<boolean> => {
    let result: boolean = false;

    const { data, status } = await callEndpoint(
      editModelUnitInBulkEndpoint(model_id, form, token),
    );

    const response = fetchResponseAdapter(data);

    if (status === 200) {
      //success
      result = true;
      setApiSuccess('Unidades actualizadas correctamente!');
    } else {
      //error
      setApiErrors(`Error en llamado al servidor: [${response.message}]`);
    }

    return result;
  };

  return {
    apiErrors,
    apiSuccess,
    isLoading,
    setApiErrors,
    setApiSuccess,
    doRetrieveUnitsPerModel,
    doActivateUnitsPerModel,
    doRetrieveUnitsPerModelViaCsv,
    doEditUnitsPerModelInBulk,
  };
};

export default useProjectModelUnit;
